import { TableHeaderCell } from 'common/components';
import type { TableFilterOption } from '../CallsTable';

type DispositionCellProps = {
    filterDisposition: string;
    dispositionOptions: TableFilterOption[];
    onFilterDisposition: (value: string) => void;
};

export const DispositionCell = ({
    filterDisposition,
    dispositionOptions,
    onFilterDisposition,
}: DispositionCellProps) => {
    const options = [{ value: '', label: 'All dispositions' }, ...dispositionOptions];
    const selectedValues = filterDisposition ? filterDisposition.split(',').filter(Boolean) : [];

    return (
        <TableHeaderCell
            label='Disposition'
            filterOptions={{
                mode: 'multi',
                options,
                selectedValues,
                onChange: (values) => onFilterDisposition(values.join(',')),
            }}
        />
    );
};
